<template>
  <div id="aqt_head">
    <router-link to="/Index">
      <img :src="msg.img" class="logo"/>
    </router-link>

    <h2 class="name">{{ msg.name }}</h2>
    <van-button :style="{backgroundColor:'#1D3662',border:'none',width:'30%',marginTop:'1rem',}" @click="showPopup">
      <img src="../assets/img/more2.png" class="more2"/>
      <!--          <div class="head_nav">-->
      <!--            <div class="line_nav"></div>-->
      <!--            <div class="line_nav"></div>-->
      <!--            <div class="line_nav"></div>-->
      <!--          </div>-->
    </van-button>

    <van-popup v-model="show" position="right" :style="{height:'100%',width:'70%'}">
      <ul class="nav">
        <img src="../assets/img/close.png" class="close" @click="hiddenSide()"/>
        <router-link v-for="(item,index) in navArr" :key="index" :to="{path:item.path}">
          <li class="nav_item" :class="{'actived':i==index}" @click="select(index)">{{ item.title }}</li>
        </router-link>
      </ul>
    </van-popup>

  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: {
        img: require('../assets/img/logo.png'),
        name: '阿启泰科技',
        img_more: require('../assets/img/more.png')
      },
      show: false,
      i: 0,
      navArr: [
        {
          path: '/Index',
          title: '首页'
        },
        {
          path: '/Server',
          title: '我们的服务'
        },
        // {
        //   path: '/News',
        //   title: '我们的新闻'
        // },
        {
          path: '/Case',
          title: '我们的案例'
        },
        {
          path: '/Product',
          title: '我们的产品'
        },
        {
          path: '/Personal',
          title: '关于我们'
        }

      ]
    }
  },
  methods: {
    showPopup() {
      this.show = true
    },
    hiddenSide() {
      this.show = false
    },
    select: function (index) {
      this.i = index
      this.show = false
    }

  }

}
</script>
<style>
#aqt_head {
  width: 100%;
  height: 4rem;
  background-color: #1D3662;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  position: fixed;
  top: 0;
  z-index: 110;
}

.logo {
  height: 2.3rem;
  margin-top: 1rem;
  margin-right: 2rem;
  margin-left: 5%;
}

.name {
  display: inline-block;
  width: 45%;
  font-size: 1.2rem;
  margin-top: 1rem;
  color: #fff;
}

.more2 {
  width: 45%;
  margin-left: 55%;
}

.head_nav {
  height: 1.8rem;
  width: 1.5rem;
  margin-top: 2rem;
  margin-left: 4rem;
  display: flex;
  flex-direction: column;
}

.line_nav {
  height: 3px;
  width: 90%;
  background-color: #fff;
  margin-top: 20%;
}

.more {
  height: 1.8rem;
  margin-top: 2rem;
  margin-left: 4rem;
}

.nav {
  width: 100%;
  height: 100%;
  background-color: #1D3662;
  border: 1px solid #1D3662;
  padding-top: 2rem;
  position: relative;
}

.nav_item {
  width: 90%;
  height: 3rem;
  color: #fff;
  margin-left: 5%;
  text-indent: 1rem;
  line-height: 3rem;
  font-size: 1rem;

}

.nav .actived {
  color: red;
  background-color: white;
}

.close {
  width: 1rem;
  position: absolute;
  top: 0.7rem;
  right: 1rem;
}
</style>
